<template>
  <a-drawer
    title="Lịch sử phê duyệt"
    placement="right"
    :closable="false"
    @close="onClose"
    :visible="visible"
  >
    <a-timeline>
      <a-timeline-item
        v-for="item in listApproval"
        :color="statusColor(item.approvalStatus)"
        :key="item.id"
        :title="statusTitle(item.approvalStatus)"
      >
        <strong title="Người duyệt">
          <a-icon type="user" />
          {{ item.author.fullname || item.author.username }} <br />
        </strong>
        <strong v-if="item.author.position" title="Chức vụ">
          <a-icon type="deployment-unit" />
          {{ item.author.position.name }}
          <br />
        </strong>

        <strong v-if="item.author.department" title="Phòng ban">
          <a-icon type="codepen" /> {{ item.author.department.name }}<br />
        </strong>

        <strong title="Thời gian duyệt">
          <a-icon type="clock-circle" />
          {{
            item.createdAt ? new Date(item.createdAt).toLocaleString() : null
          }}
          <br />
        </strong>

        <span v-if="item.approvalNote" title="Ý kiến">
          <strong><a-icon type="edit"/></strong> {{ item.approvalNote }}
        </span>

        <!-- Bước duyệt: {{ item.approvalCurrentStep }}<br />
      Trạng thái: {{ item.approvalStatus }}<br /> -->
      </a-timeline-item>
    </a-timeline>
  </a-drawer>
</template>
<script>
export default {
  props: {
    onClose: {
      type: Function,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    statusColor(status) {
      if (status === "Approved") {
        return "green";
      } else if (status === "Pending") {
        return "blue";
      } else if (status === "Editting") {
        return "#e6e53d";
      } else if (status === "Rejected") {
        return "red";
      } else {
        return "gray";
      }
    },
    statusTitle(status) {
      if (status === "Approved") {
        return "Đồng ý duyệt";
      } else if (status === "Pending") {
        return "Trình duyệt";
      } else if (status === "Rejected") {
        return "Không đồng ý duyệt";
      } else {
        return "Yêu cầu chỉnh sửa";
      }
    }
  },
  computed: {
    listApproval() {
      if (this.$store.state.form) {
        return this.$store.state.form.approvalSteps;
      } else {
        return undefined;
      }
    }
  }
};
</script>
